import React from "react";

const getTodayEvening = () => {
  const now = new Date();
  const evening = new Date(now);
  evening.setHours(20, 0, 0, 0);
  if (evening < now) {
    evening.setDate(evening.getDate() + 1);
   }
  return evening.toISOString().replace('Z', '+00:00').substring(0, 16);
};

export const defaultFormValues = () => {
    const stored = window.localStorage.getItem('formValues');
    if (stored) {
        try { return JSON.parse(stored); } catch(e) { /* fall through */ }
   }
    return {
      origin_airport: '',
      departureSideStartDate: getTodayEvening(),
      arrivalSideEndDate: getTodayEvening(),
      arrivalSideStartDate: getTodayEvening(),
      departureSideEndDate: getTodayEvening(),
      destination_airport: '',
      numberOfAdults: '1',
      numberOfChildren: '0',
      numberOfInfants: '0',
      singleTrip: false
   };
};
export const defaultDetails = () => window.localStorage.getItem('details')?JSON.parse(window.localStorage.getItem('details')):{
  surname: '',
  firstname: '',
  email: '',
  phone: '',
  flightNumber: '',
  flightArrival: '',
  flightDeparture: '',
  ffp: ''
}
export default React.createContext({
  contextData: {
    formValues: defaultFormValues(),
    details: defaultDetails(),
    responseId: 0,
    orderId: 0,
    transfer: null,
    lounge: null,
    parking: null,
    user: null,
    authKey: null,
    cart: null,
    cartSum: null,
    activationSuccess: false,
    activationFailure: false
  },
  setFormValues: (e, fieldName) => {},
  setResponseId: (id) => {}
});
